import { isNil, some, every, isEqual } from 'lodash';
import {
    getActualFilters,
    getQueryParams,
} from './refinementUtils';

const lotNoKey = 'lotNo';
const horseNameKey = 'horseName';

// TODO: it might be moved to config
export const catalogueStateKey = 'catalogue';
export const cataloguePagerLength = 5;

export function getCatalogueDataset() {
    return document.getElementById('root').dataset;
}

export function isCatalogueUpcoming() {
    return getCatalogueDataset().upcoming === 'true';
}

export function getCatalogueFilterOptionsKey(filterKey) {
    return `${filterKey}Options`;
}

export function isFilteringEmpty(refinement) {
    return every(refinement, value => !value && value !== 0);
}

export function isHorseNameFilterDisabled(refinement) {
    return some(refinement, (value, key) => key !== horseNameKey && value);
}

export function isCommonFilterDisabled(refinement) {
    return !isNil(refinement[lotNoKey]) || !isNil(refinement[horseNameKey]);
}

export function isCommonFiltersTabDisabled(refinement) {
    return isCommonFilterDisabled(refinement);
}

export function isHorseFiltersTabDisabled(refinement) {
    return !isNil(refinement[lotNoKey]);
}

export function getInitialRefinement() {
    return {
        minPrice: null,
        maxPrice: null,
        entered: false,
        price: false,
        lotNo: null,
        horseName: null,
        horseSex: null,
        horseAge: null,
        sireName: null,
        damName: null,
        sireOfDamName: null,
        sellerName: null,
        buyerDetail: null
    };
}

export function isRefinementUsed(refinement) {
    return !isEqual(refinement, getInitialRefinement());
}

function getCatalogueActualFilters(refinement, excludedKey) {
    const lotNo = refinement[lotNoKey];
    if (!isNil(lotNo)) {
        return { lotNo };
    }

    return getActualFilters(refinement, [excludedKey]);
}

export function getCatalogueQueryParams(refinement, page, excludedKey) {
    return getQueryParams(refinement, page, excludedKey, getCatalogueActualFilters);
}

export function getCatalogueFiltersLabel({ refinement, refinementHistory, data }) {
    const excludedFilters = ['minPrice', 'maxPrice'];
    const actualFilters = getActualFilters(refinement, excludedFilters);
    return refinementHistory
        .filter(({ key }) => actualFilters.hasOwnProperty(key))
        .map(({ key, value }) => {
            switch (key) {
                case 'lotNo':
                    return `lot ${value}`;
                case 'entered':
                    return 'only lots with entries';
                case 'price':
                    return 'only sold lots';
                default: {
                    const options = data[getCatalogueFilterOptionsKey(key)];
                    const option = options.find(item => item.value === value) || { name: '' };
                    return option.name;
                }
            }
        })
        .join(', ');
}

/**
 * State selector for catalogue refinement
 * @param state
 */
export function refinementSelector(state) {
    return state.refinement;
}



// WEBPACK FOOTER //
// ./src/js/helpers/catalogueUtils.js